export const initialState = {
    filter: {
        personName: null,
        personSurname: null,
        province: null,
        town: null,
        levelEducation: null,
        state: null,
        profession: null ,
        yearsExperience: null,
        vacantId: null,
    },
    isFilter: false,
  };
  
  const filterPostulatesReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_FILTER_POSTULATES":
        return {
          ...state,
          filter: action.filter,
          isFilter: action.isFilter,
        };
      default:
        return state;
    }
  };
  
  export default filterPostulatesReducer;
  